import { useState } from 'react';
import { CBadge, CButton, CFormInput } from '@coreui/react';
import type { PositionRow } from './types.js';

interface Props {
    row: PositionRow;
    onSetOverride: (symbol: string, entryDate: string | null) => void;
}

export const EntryDateOverrideCell = ({ row, onSetOverride }: Props) => {
    const [editing, setEditing] = useState(false);
    const [pendingValue, setPendingValue] = useState(row.entryDate ?? '');

    if (!editing) {
        return (
            <div className="d-flex align-items-center gap-1" onClick={(e) => e.stopPropagation()}>
                <span>{row.entryDate ?? '—'}</span>
                {row.entryDateSource === 'manual' && (
                    <CBadge color="info" shape="rounded-pill">
                        Manual
                    </CBadge>
                )}
                <CButton
                    size="sm"
                    color="secondary"
                    variant="ghost"
                    onClick={() => {
                        setPendingValue(row.entryDate ?? '');
                        setEditing(true);
                    }}
                >
                    Edit
                </CButton>
            </div>
        );
    }

    return (
        <div className="d-flex align-items-center gap-1" onClick={(e) => e.stopPropagation()}>
            <CFormInput
                type="date"
                size="sm"
                style={{ width: 150 }}
                value={pendingValue}
                onChange={(e) => setPendingValue(e.target.value)}
            />
            <CButton
                size="sm"
                color="primary"
                variant="outline"
                disabled={!pendingValue}
                onClick={() => {
                    onSetOverride(row.symbol, pendingValue);
                    setEditing(false);
                }}
            >
                Set
            </CButton>
            {row.entryDateSource === 'manual' && (
                <CButton
                    size="sm"
                    color="secondary"
                    variant="outline"
                    onClick={() => {
                        onSetOverride(row.symbol, null);
                        setEditing(false);
                    }}
                >
                    Reset to default
                </CButton>
            )}
            <CButton size="sm" color="secondary" variant="ghost" onClick={() => setEditing(false)}>
                Cancel
            </CButton>
        </div>
    );
};
